module.exports = __webpack_public_path__ + "img/组 1.bd67d456.webp";